var map = {
	"./CivilandCommercalLitigation.jpg": 64,
	"./CriminalLaw.jpg": 65,
	"./SaleandPurchaseofProperty.jpg": 66,
	"./TrafficLaw.jpg": 67,
	"./harbour.jpg": 68,
	"./jonathanabiharb.jpg": 63,
	"./logo.jpg": 105,
	"./logo_full.jpg": 106,
	"./samabbas.jpg": 62
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 104;